import { Grid2 } from "@mui/material"

export function ReportRow({ item, columns }) {
    return (
        <Grid2 container sx={{ border: "1px solid #ddd", width: "100%", bgcolor: "#fff", alignItems: "center" }}>
            {columns.map((column, i) => (
                <Grid2 key={i} size={column.size} sx={{ padding: "4px" }}>
                    {item[column.value]}
                </Grid2>
            ))}
        </Grid2>
    )
}
